import { Modal, ModalProps } from 'antd';
import styled from 'styled-components';
import { ModalBody, ModalFooter } from '~/components/Globals';

export const ModalContainer = styled(Modal) <ModalProps>`
  .ant-modal-close,
  .anticon-close {
    padding: 8px;
    color: #black !important;
  }

  .ant-modal-body {
    padding: 0 !important;
  }

  .ant-modal-footer {
    display: none;
  }
`;

export const Body = styled(ModalBody)`
  padding: 24px 24px 8px;
`;

export const Title = styled.h3`
  font-size: 1.5rem;
  font-weight: 500;
  line-height: 30px;
  text-align: left;
  color: #000;
  margin-bottom: 16px;
`;

export const ColumnList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 600px;
  overflow-y: auto;
  padding-right: 8px;
  
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const ColumnItem = styled.div`
  display: flex;
  align-items: center;
  font-size: 1rem;
  font-weight: 400;
  line-height: 20px;
  color: #464646;
`;

export const Footer = styled(ModalFooter)`
  border: 0;
  padding: 16px 24px 24px;
`;